// extracted by mini-css-extract-plugin
module.exports = {"platforms":"_platforms-styles-module--platforms--1NBtY","primaryButton":"_platforms-styles-module--primaryButton--1wdfq","callout":"_platforms-styles-module--callout--RvQLn"};